/**
 *
 * @module orderSubmissionEnvironment
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class OrderSubmissionEnvironment
 *
 */
export default class OrderSubmissionEnvironment {

    /**
     *
     * @param {String} [ipAddress=undefined]
     * @param {String} [referringUri=undefined]
     * @param {String} [submittingHost=undefined]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(ipAddress, referringUri, submittingHost) {

        const errorMessage = {
            ctor: 'OrderSubmissionEnvironment(ipAddress, referringUri, submittingHost)',
            get ipAddress() {
                return `${this.ctor} ipAddress should be a String with length`;
            },
            get referringUri() {
                return `${this.ctor} referringUri should be a String with length`;
            },
            get submittingHost() {
                return `${this.ctor} submittingHost should be a String with length`;
            }
        };

        if (Check.assigned(ipAddress)) {
            nonEmptyString(ipAddress, errorMessage.ipAddress, InvalidArgumentException);
        }

        if (Check.assigned(referringUri)) {
            nonEmptyString(referringUri, errorMessage.referringUri, InvalidArgumentException);
        }

        if (Check.assigned(submittingHost)) {
            nonEmptyString(submittingHost, errorMessage.submittingHost, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.ipAddress = ipAddress;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.referringUri = referringUri;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.submittingHost = submittingHost;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/orderSubmissionEnvironment.js